const stopPropagation = (e: React.SyntheticEvent) => e.stopPropagation();
export default stopPropagation;
